/** ***********************************************************************
 *
 * ADOBE CONFIDENTIAL
 * ___________________
 *
 *  Copyright 2019 Adobe Systems Incorporated
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Adobe Systems Incorporated and its suppliers,
 * if any.  The intellectual and technical concepts contained
 * herein are proprietary to Adobe Systems Incorporated and its
 * suppliers and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Adobe Systems Incorporated.
 ************************************************************************* */

import resolveResponse from 'contentful-resolve-response';
import { AllHtmlEntities } from 'html-entities';
/**
     * processObj function
     * helper function
     */
const processObj = (object, initialItemMap, processedItemMap) => {
    const retJson = {};

    if (!Object.prototype.hasOwnProperty.call(object, 'sys') || !Object.prototype.hasOwnProperty.call(object, 'fields')) {
        if (Array.isArray(object)) {
            const retArray = [];
            object.forEach((element) => {
                if (typeof element === 'object') {
                    retArray.push(processObj(element, initialItemMap, processedItemMap));
                } else {
                    retArray.push(element);
                }
            });
            return retArray;
        }
        Object.keys(object).forEach((key) => {
            if (typeof object[key] === 'object') {
                retJson[key] = processObj(object[key], initialItemMap, processedItemMap);
            } else {
                retJson[key] = object[key];
            }
        });
        return retJson;
    }
    const sysId = object.sys.id;
    if (processedItemMap.has(sysId)) {
        return processedItemMap[sysId];
    }
    const { fields } = object;
    retJson.sys_id = sysId;
    Object.keys(fields).forEach((key) => {
        if (typeof fields[key] === 'object') {
            retJson[key] = processObj(fields[key], initialItemMap, processedItemMap);
        } else {
            retJson[key] = fields[key];
        }
    });

    // eslint-disable-next-line
    processedItemMap[object.sys.id] = retJson;
    return retJson;
};

class ContentParser {
    /**
     * parse function
     * Converts Contentful data to hirerchical data
     * @return {object}
     */
    parse(data) {
        const retArray = [];
        const initialItemMap = new Map();
        const processedItemMap = new Map();
        const items = resolveResponse(data); // Merges linked includes to items
        items.forEach(element => initialItemMap.set(element.sys.id, element));
        initialItemMap.forEach((value, key) => {
            processObj(initialItemMap.get(key),
                initialItemMap,
                processedItemMap);
        });
        initialItemMap.forEach((value, key) => {
            retArray.push(processedItemMap[key]);
        });
        return { items: retArray };
    }

    processText(contentfulText) {
        const entities = new AllHtmlEntities();
        return entities.decode(contentfulText);
    }

    getAssetPath(asset, basePath) {
	    if (asset && asset.file) return (basePath && asset.file.path) ? `file:///${basePath}${asset.file.path}` : asset.file.url;
        // eslint-disable-next-line no-underscore-dangle
        if (asset) return (basePath && asset._path) ? `file:///${basePath}${asset._path}` : asset._publishUrl;
	    return undefined;
    }
}
export default new ContentParser();
